export default function ($el) {
  let $toggle = $el.parent().find('.toggle');

  if (!$toggle.length) {
    $toggle = $("<a class='toggle p40' data-hidden='true'>Show</a>");
    $el.parent().append($toggle);
  } else {
    $toggle.attr('data-hidden', 'true');
  }

  $toggle.on('click', () => {
    if ($toggle.data('hidden') === true) {
      $toggle.html('Hide');
      $el.attr('type', 'text');
      $toggle.data('hidden', false);
    } else {
      $toggle.html('Show');
      $el.attr('type', 'password');
      $toggle.data('hidden', true);
    }
  });
}
